import { CanvasColorTheme } from "../interfaces/CanvasColorTheme";

// export const CANVAS_BACKGROUND_COLOR = "#012531";
export const CANVAS_BACKGROUND_COLOR = "#111e28";
export const CANVAS_ITEM_GLOW_COLOR = "#12e9f966";
export const CANVAS_ITEM_TEXT_FONT = "Teko";
export const CANVAS_ITEM_TEXT_FONT_WEIGHT = "500";
// export const CANVAS_ARROW_COLOR = "#12EAF9";
export const CANVAS_ARROW_COLOR = "#87a0aa";
export const CANVAS_ARROW_HIGHLIGHT_COLOR = "orange";

export const COLOR_01: CanvasColorTheme = {
    bgColor: "#603e1c",
    headerColor: "#603e1c",
    textColor: "#f9ac78",
    strokeColor: "#f9ac78",
    subTextColor:"#ffd8ae",
    glowColor:"#f9ac78",
    innerStrokeColor:"#95643c",
    transparencyBackground:"#2b3136",
    name: "color_01"
}

export const COLOR_02: CanvasColorTheme = {
    bgColor: "#604b29",
    headerColor: "#42321d",
    textColor: "#ffca6c",
    strokeColor: "#ffca6c",
    subTextColor:"#ffe1a6",
    glowColor:"#ffca6c",
    innerStrokeColor:"#977841",
    transparencyBackground:"#2c3435",
    name: "color_02"
}

export const COLOR_03: CanvasColorTheme = {
    bgColor: "#5e5017",
    headerColor: "#443b21",
    textColor: "#efdd75",
    strokeColor: "#efdd75",
    subTextColor:"#fff1ab",
    glowColor:"#efdd75",
    innerStrokeColor:"#918138",
    transparencyBackground:"#2a3635",
    name: "color_03"
}

export const COLOR_04: CanvasColorTheme = {
    bgColor: "#514d30",
    headerColor: "#33321c",
    textColor: "#fffc8a",
    strokeColor: "#fffc8a",
    subTextColor:"#fffda6",
    glowColor:"#fffc8a",
    innerStrokeColor:"#8a884d",
    transparencyBackground:"#2c3837",
    name: "color_04"
}

export const COLOR_05: CanvasColorTheme = {
    bgColor: "#4a512f",
    headerColor: "#333822",
    textColor: "#e1ff8f",
    strokeColor: "#e1ff8f",
    subTextColor:"#f1ffc0",
    glowColor:"#e1ff8f",
    innerStrokeColor:"#7f8e51",
    transparencyBackground:"#293938",
    name: "color_05"
}
 
export const COLOR_06: CanvasColorTheme = {
    bgColor: "#3f5630",
    headerColor: "#2f3d24",
    textColor: "#b5ff8a",
    strokeColor: "#b5ff8a",
    subTextColor:"#d9ffc0",
    glowColor:"#b5ff8a",
    innerStrokeColor:"#68914f",
    transparencyBackground:"#253937",
    name: "color_06"
}

export const COLOR_07: CanvasColorTheme = {
    bgColor: "#314907",
    headerColor: "#253805",
    textColor: "#83ff89",
    strokeColor: "#83ff89",
    subTextColor:"#c9e8ac",
    glowColor:"#83ff89",
    innerStrokeColor:"#55840e",
    transparencyBackground:"#213937",
    name: "color_07"
}

export const COLOR_08: CanvasColorTheme = {
    bgColor: "#064f46",
    headerColor: "#043a30",
    textColor: "#14f7a0",
    strokeColor: "#14f7a0",
    subTextColor:"#abedda",
    glowColor:"#14f7a0",
    innerStrokeColor:"#0b8966",
    transparencyBackground:"#1c393b",
    name: "color_08"
}

export const COLOR_09: CanvasColorTheme = {
    bgColor: "#00484c",
    headerColor: "#00363a",
    textColor: "#00eace",
    strokeColor: "#00eace",
    subTextColor:"#fff1ab",
    glowColor:"#00eace",
    innerStrokeColor:"#008179",
    transparencyBackground:"#15373d",
    name: "color_09"
}

export const COLOR_10: CanvasColorTheme = {
    bgColor: "#044253",
    headerColor: "#04323d",
    textColor: "#12e4f9",
    strokeColor: "#12e4f9",
    subTextColor:"#abe8ef",
    glowColor:"#12e4f9",
    innerStrokeColor:"#097b8d",
    transparencyBackground:"#153640",
    name: "color_10"
}

export const COLOR_11: CanvasColorTheme = {
    bgColor: "#213b4f",
    headerColor: "#1a2e3f",
    textColor: "#6ed3ff",
    strokeColor: "#6ed3ff",
    subTextColor:"#99e5ff",
    glowColor:"#6ed3ff",
    innerStrokeColor:"#3b708c",
    transparencyBackground:"#1f3542",
    name: "color_11"
}

export const COLOR_12: CanvasColorTheme = {
    bgColor: "#183756",
    headerColor: "#09293d",
    textColor: "#8fc7ff",
    strokeColor: "#8fc7ff",
    subTextColor:"#a1d5ff",
    glowColor:"#8fc7ff",
    innerStrokeColor:"#426a91",
    transparencyBackground:"#223442",
    name: "color_12"
}

export const COLOR_13: CanvasColorTheme = {
    bgColor: "#20325b",
    headerColor: "#182742",
    textColor: "#a9c6ff",
    strokeColor: "#a9c6ff",
    subTextColor:"#bdd6ff",
    glowColor:"#a9c6ff",
    innerStrokeColor:"#506694",
    transparencyBackground:"#243442",
    name: "color_13"
}

export const COLOR_14: CanvasColorTheme = {
    bgColor: "#302559",
    headerColor: "#221b44",
    textColor: "#c6b8ff",
    strokeColor: "#c6b8ff",
    subTextColor:"#ded4ff",
    glowColor:"#c6b8ff",
    innerStrokeColor:"#645893",
    transparencyBackground:"#273242",
    name: "color_14"
}

export const COLOR_15: CanvasColorTheme = {
    bgColor: "#341e51",
    headerColor: "#26143d",
    textColor: "#d6b0ff",
    strokeColor: "#d6b0ff",
    subTextColor:"#e7d4ff",
    glowColor:"#d6b0ff",
    innerStrokeColor:"#6d528e",
    transparencyBackground:"#283242",
    name: "color_15"
}

export const COLOR_16: CanvasColorTheme = {
    bgColor: "#451e54",
    headerColor: "#37143f",
    textColor: "#e4b0ff",
    strokeColor: "#e4b0ff",
    subTextColor:"#e6ccff",
    glowColor:"#e4b0ff",
    innerStrokeColor:"#7b5190",
    transparencyBackground:"#293242",
    name: "color_16"
}

export const COLOR_17: CanvasColorTheme = {
    bgColor: "#4c1e3a",
    headerColor: "#38172b",
    textColor: "#ffbbe7",
    strokeColor: "#ffbbe7",
    subTextColor:"#ffd2ef",
    glowColor:"#ffbbe7",
    innerStrokeColor:"#8c5775",
    transparencyBackground:"#2c3340",
    name: "color_17"
}

export const COLOR_18: CanvasColorTheme = {
    bgColor: "#561d2f",
    headerColor: "#3d0e1d",
    textColor: "#ffa6bf",
    strokeColor: "#ffa6bf",
    subTextColor:"#ffc7db",
    glowColor:"#ffa6bf",
    innerStrokeColor:"#914d62",
    transparencyBackground:"#2c313c",
    name: "color_18"
}

export const COLOR_19: CanvasColorTheme = {
    bgColor: "#511c1c",
    headerColor: "#350a0a",
    textColor: "#f9a5a5",
    strokeColor: "#f9a5a5",
    subTextColor:"#efbfbf",
    glowColor:"#f9a5a5",
    innerStrokeColor:"#8c4c4c",
    transparencyBackground:"#2b313a",
    name: "color_19"
}

// export const COLOR_01: CanvasColorTheme = {
//     outterColor: "#f9a5a5",
//     bgColor: "#511c1c",
//     headerColor: "#350a0a",
//     textColor: "#f9a5a5",
//     strokeColor: "#f9a5a5",
//     subTextColor:"#efbfbf",
//     glowColor:"#f9a5a566",
//     innerStrokeColor:"#8c4c4c",
//     transparencyBackground:"#2b313a",
//     name: "color_01"
// }

// export const COLOR_02: CanvasColorTheme = {
//     outterColor: "#ffa6bf",
//     bgColor: "#561d2f",
//     headerColor: "#3d0e1d",
//     textColor: "#ff94b3",
//     strokeColor: "#ff94b3",
//     subTextColor:"#ffc7db",
//     glowColor:"#ff94b366",
//     innerStrokeColor:"#914d62",
//     transparencyBackground:"#2c313c",
//     name: "color_02"
// }

// export const COLOR_03: CanvasColorTheme = {
//     outterColor: "#e4b0ff",
//     bgColor: "#451e54",
//     headerColor: "#37143f",
//     textColor: "#e4b0ff",
//     strokeColor: "#e4b0ff",
//     subTextColor:"#e6ccff",
//     glowColor:"#e4b0ff66",
//     innerStrokeColor:"#7b5190",
//     transparencyBackground:"#293242",
//     name: "color_03"
// }

// export const COLOR_04: CanvasColorTheme = {
//     outterColor: "#d6b0ff",
//     bgColor: "#341e51",
//     headerColor: "#26143d",
//     textColor: "#d6b0ff",
//     strokeColor: "#d6b0ff",
//     subTextColor:"#e7d4ff",
//     glowColor:"#d6b0ff66",
//     innerStrokeColor:"#6d528e",
//     transparencyBackground:"#283242",
//     name: "color_04"
// }

// export const COLOR_05: CanvasColorTheme = {
//     outterColor: "#12e4f9",
//     bgColor: "#044253",
//     headerColor: "#04323d",
//     textColor: "#12e4f9",
//     strokeColor: "#12e4f9",
//     subTextColor:"#abe8ef",
//     glowColor:"#12e4f966",
//     innerStrokeColor:"#097b8d",
//     transparencyBackground:"#153640",
//     name: "color_05"
// }

// export const COLOR_06: CanvasColorTheme = {
//     outterColor: "#8fc7ff",
//     bgColor: "#183756",
//     headerColor: "#09293d",
//     textColor: "#8fc7ff",
//     strokeColor: "#8fc7ff",
//     subTextColor:"#a1d5ff",
//     glowColor:"#8fc7ff66",
//     innerStrokeColor:"#426a91",
//     // transparencyBackground:"#8fc7ff59",
//     transparencyBackground:"#223442",
//     name: "color_06"
// }

// export const COLOR_07: CanvasColorTheme = {
//     outterColor: "#14f7a0",
//     bgColor: "#064f46",
//     headerColor: "#043a30",
//     textColor: "#14f7a0",
//     strokeColor: "#14f7a0",
//     subTextColor:"#abedda",
//     glowColor:"#14f7a066",
//     innerStrokeColor:"#0b8966",
//     // transparencyBackground:"#14f7a059",
//     transparencyBackground:"#1c393b",
//     name: "color_07"
// }

// export const COLOR_08: CanvasColorTheme = {
//     outterColor: "#b5ff8a",
//     bgColor: "#3f5630",
//     headerColor: "#2f3d24",
//     textColor: "#b5ff8a",
//     strokeColor: "#b5ff8a",
//     subTextColor:"#d9ffc0",
//     glowColor:"#b5ff8a66",
//     innerStrokeColor:"#68914f",
//     transparencyBackground:"#293938",
//     name: "color_08"
// }

// export const COLOR_09: CanvasColorTheme = {
//     outterColor: "#efdd75",
//     bgColor: "#5e5017",
//     headerColor: "#443b21",
//     textColor: "#efdd75",
//     strokeColor: "#efdd75",
//     subTextColor:"#fff1ab",
//     glowColor:"#efdd7566",
//     innerStrokeColor:"#918138",
//     transparencyBackground:"#2a3635",
//     name: "color_09"
// }

// export const COLOR_10: CanvasColorTheme = {
//     outterColor: "#f9ac78",
//     bgColor: "#603f1b",
//     headerColor: "#442e1a",
//     textColor: "#f9ac78",
//     strokeColor: "#f9ac78",
//     subTextColor:"#ffd8ae",
//     glowColor:"#f9ac7866",
//     innerStrokeColor:"#95643c",
//     transparencyBackground:"#2b3136",
//     name: "color_10"
// }

// export const COLOR_11: CanvasColorTheme = {
//     outterColor: "#87a0aa",
//     bgColor: "#17242e",
//     headerColor: "#87a0aa",
//     textColor: "#87a0aa",
//     strokeColor: "#87a0aa",
//     subTextColor:"#87a0aa",
//     glowColor:"#87a0aa",
//     innerStrokeColor:"#87a0aa",
//     transparencyBackground:"#17242e",
//     name: "color_11"
// }

export const COLOR_20: CanvasColorTheme = {
    // outterColor: "#87a0aa",
    bgColor: "#212f38",
    headerColor: "#87a0aa",
    textColor: "#87a0aa",
    strokeColor: "#87a0aa",
    subTextColor:"#87a0aa",
    glowColor:"#87a0aa",
    innerStrokeColor:"#87a0aa",
    transparencyBackground:"#212f38",
    name: "color_20"
}

export const COLOR_21: CanvasColorTheme = {
    // outterColor: "#87a0aa",
    bgColor: "#ffffff00",
    headerColor: "#87a0aa",
    textColor: "#87a0aa",
    strokeColor: "#87a0aa",
    subTextColor:"#87a0aa",
    glowColor:"#87a0aa",
    innerStrokeColor:"#87a0aa",
    transparencyBackground:"#ffffff00",
    name: "color_21"
}

export const CANVAS_BOX_THEMES: CanvasColorTheme[] = [
    // DEFAULT_COLOR,
    COLOR_01,
    COLOR_02,
    COLOR_03,
    COLOR_04,
    COLOR_05,
    COLOR_06,
    COLOR_07,
    COLOR_08,
    COLOR_09,
    COLOR_10,
    COLOR_11,
    COLOR_12,
    COLOR_13,
    COLOR_14,
    COLOR_15,
    COLOR_16,
    COLOR_17,
    COLOR_18,
    COLOR_19,
    COLOR_20,
    COLOR_21,
]

export const THEME_CHOOSER = [
    // {
    //     color: DEFAULT_COLOR.bgColor,
    //     theme: DEFAULT_COLOR
    // },
    {
        color: COLOR_01.bgColor,
        theme: COLOR_01,
        name: COLOR_01.name
    },
    {
        color: COLOR_02.bgColor,
        theme: COLOR_02,
        name: COLOR_02.name
    },
    {
        color: COLOR_03.bgColor,
        theme: COLOR_03,
        name: COLOR_03.name
    },
    {
        color: COLOR_04.bgColor,
        theme: COLOR_04,
        name: COLOR_04.name
    },
    {
        color: COLOR_05.bgColor,
        theme: COLOR_05,
        name: COLOR_05.name
    },
    {
        color: COLOR_06.bgColor,
        theme: COLOR_06,
        name: COLOR_06.name
    },
    {
        color: COLOR_07.bgColor,
        theme: COLOR_07,
        name: COLOR_07.name
    },
    {
        color: COLOR_08.bgColor,
        theme: COLOR_08,
        name: COLOR_08.name
    },
    {
        color: COLOR_09.bgColor,
        theme: COLOR_09,
        name: COLOR_09.name
    },
    {
        color: COLOR_10.bgColor,
        theme: COLOR_10,
        name: COLOR_10.name
    },
    {
        color: COLOR_11.bgColor,
        theme: COLOR_11,
        name: COLOR_11.name
    },
    {
        color: COLOR_12.bgColor,
        theme: COLOR_12,
        name: COLOR_12.name
    },
    {
        color: COLOR_13.bgColor,
        theme: COLOR_13,
        name: COLOR_13.name
    },
    {
        color: COLOR_14.bgColor,
        theme: COLOR_14,
        name: COLOR_14.name
    },
    {
        color: COLOR_15.bgColor,
        theme: COLOR_15,
        name: COLOR_15.name
    },
    {
        color: COLOR_16.bgColor,
        theme: COLOR_16,
        name: COLOR_16.name
    },
    {
        color: COLOR_17.bgColor,
        theme: COLOR_17,
        name: COLOR_17.name
    },
    {
        color: COLOR_18.bgColor,
        theme: COLOR_18,
        name: COLOR_18.name
    },
    {
        color: COLOR_19.bgColor,
        theme: COLOR_19,
        name: COLOR_19.name
    },
    {
        color: COLOR_20.bgColor,
        theme: COLOR_20,
        name: COLOR_20.name
    },
    {
        color: COLOR_21.bgColor,
        theme: COLOR_21,
        name: COLOR_21.name
    }
]

export function GetThemeByName(name: string): CanvasColorTheme{
    return CANVAS_BOX_THEMES.find((c)=>c.name === name)!;
}